import createDOMPurify from "dompurify";

const domPurify= createDOMPurify(window)

export default domPurify;